import { CommApiInstance } from "Utils/CommApiInstance";

const MembNtfyMsgLstInqApi = async (
    page:number|null,
    ntfyMsgSttuCd:String
) => {
    return await CommApiInstance.post(`memb/ntfy_msg_lst?page=${page}`,{
        apiBody:{
            ntfyMsgSttuCd:ntfyMsgSttuCd
        },
    })
    .then((Resp) => Resp.data);
}
export default MembNtfyMsgLstInqApi;